import { BinIcon } from "../../../../components/icon/Icon";
import { BonusTimeMobileStyled } from "./styled/BonusTimeMobileStyled";
import { useMemo } from "react";
import moment from "moment";
import { useBonusContext } from "../../bonusContext";

function BonusTimeMobile() {
    const {bonusAvailableSecondsLeft} = useBonusContext();

    const time = useMemo(() => {
        const duration = moment.duration(bonusAvailableSecondsLeft, 'seconds');
        return moment.utc(duration.asMilliseconds()).format('HH[h] mm[m] ss[s]');
    }, [bonusAvailableSecondsLeft]);

    return <BonusTimeMobileStyled>
        <BinIcon name="IcStopwatch"/>
        <span>{time}</span>
    </BonusTimeMobileStyled>
}

export default BonusTimeMobile;
